import { useCallback, useMemo } from "react";
import { type WorkflowStepInput, type WorkflowTemplate } from "~/api/types";
import useUsers from "~/api/swr/useUsers";
import { UserStatus, PlatformRole } from "~/config/types";
import {
  buildUserDisplayMap,
  hydrateTemplateSteps,
  type UserDisplayMap,
} from "~/helpers/workflow";

export function useWorkflowUsers() {
  const { data: allUsers } = useUsers({
    status: [UserStatus.active, UserStatus.pending],
    roles: [
      PlatformRole.superAdmin,
      PlatformRole.coordinator,
      PlatformRole.contributor,
    ],
  });

  const userMap: UserDisplayMap = useMemo(
    () => buildUserDisplayMap(allUsers),
    [allUsers],
  );

  const hydrateSteps = useCallback(
    (template: WorkflowTemplate): WorkflowStepInput[] =>
      hydrateTemplateSteps(template.steps, userMap),
    [userMap],
  );

  return { userMap, hydrateSteps };
}
